var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vacancy-workdays-progress',{attrs:{"workdays-in-work":_vm.inWork,"workdays-before-deadline":_vm.beforeDeadline,"workdays-after-deadline":_vm.afterDeadline}})
}
var staticRenderFns = []

export { render, staticRenderFns }